export const TILE_HOST = 'https://ct3.wettercomassets.com/';



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/Utils/Constants.js
 **/